export default {
	id: 'SIMPLE_CANCEL_OFFER_1M_5',
	providers: {
		paltaMap: {
			USD: 'simple_premium_1m_5_usd',
			EUR: 'simple_premium_1m_5_eur',
			GBP: 'simple_premium_1m_5_gbp',
			CAD: 'simple_premium_1m_7_cad',
			AUD: 'simple_premium_1m_7_aud',
			DKK: 'simple_premium_1m_30_dkk',
			SEK: 'simple_premium_1m_50_sek',
			NOK: 'simple_premium_1m_50_nok',
			TRY: 'simple_premium_1m_200_try',
			MXN: 'simple_premium_1m_90_mxn',
			BRL: 'simple_premium_1m_25_brl',
			ARS: 'simple_premium_1m_5500_ars',
			COP: 'simple_premium_1m_20000_cop',
			CLP: 'simple_premium_1m_5000_clp',
			PLN: 'simple_premium_1m_20_pln',
		},
		primer: 'prd_7x0tVGPDowvf',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 0,
		priceMap: {},
		originalPriceMap: {},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 5.0,
			EUR: 5.0,
			GBP: 5.0,
			CAD: 7.0,
			AUD: 7.0,
			DKK: 30.0,
			SEK: 50.0,
			NOK: 50.0,
			TRY: 200.0,
			MXN: 90.0,
			BRL: 25.0,
			ARS: 5500.0,
			COP: 20000.0,
			CLP: 5000.0,
			PLN: 20.0,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.cancel_offer.plans.1_month.into_period_text'), // 'monthly'
		explicitTermsIntervalText: $t('pages.program.cancel_offer.plans.1_month.sub_period_text'), // 'monthly'
		billingSubtitlePeriodText: $t('pages.program.cancel_offer.plans.1_month.into_period_text'), // 'monthly'
		footerPeriodText: $t('pages.program.cancel_offer.plans.1_month.period_text'), // '1-month'
		footerIntervalText: $t('pages.program.cancel_offer.plans.1_month.sub_period_text'), // 'monthly'
	}),
}
